import { render } from "./ProfilePage.vue?vue&type=template&id=ff438778&scoped=true&ts=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"

import "./ProfilePage.vue?vue&type=style&index=0&id=ff438778&lang=scss&scoped=true"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff438778"]])

export default __exports__